import { Play, PreloadImage, Translate } from '@nackle/arcade-core-v2';
import { Spin, Button, Typography, NackleProgramTile } from '@nackle/origami';
import { CaretRight } from '@nackle/origami-icons';
import React from 'react';
import { connect } from 'react-redux';
import AltLocaleString from '../../components/AltLocaleString';
import { getUmbrellaImageUrl } from '../utils/umbrellaImageUrl';
import translationCache from '../../utils/cache';

import './InstantPlay.less';

const { Title } = Typography;

const mapDispatchToProps = {
    openGame: Play.openGame,
};

class InstantPlay extends React.Component {
    state = {
        cacheBundle: translationCache.mergedBundle,
    };
    unsubscribeTranslationCache = null;

    componentDidMount() {
        this.unsubscribeTranslationCache = translationCache.subscribe( ( mergedBundle ) => {
            this.setState( { cacheBundle: mergedBundle } );
        } );
    }

    componentWillUnmount() {
        if ( this.unsubscribeTranslationCache ) {
            this.unsubscribeTranslationCache();
        }
    }

    render() {
        const {
            cabinet,
            romId,
            isUmbrella,
        } = this.props;
        const {
            foregroundLoaded,
            backgroundLoaded,
            cacheBundle,
        } = this.state;
        const foregroundImageUrl = getUmbrellaImageUrl( cabinet.instantPlayForegroundImageUrl, isUmbrella, '' );
        const backgroundImageUrl = getUmbrellaImageUrl(
            cabinet.instantPlayBackgroundImageUrl || cabinet.image || cabinet.bannerImage,
            isUmbrella,
            '',
        );

        const imagesLoaded = ( foregroundLoaded || !foregroundImageUrl ) && backgroundLoaded;
        const label = cabinet.name;
        const romName = cacheBundle[ `rom.${ romId }.name` ];
        const romDescription = cacheBundle[ `rom.${ romId }.description` ];

        return (
            <div>
                { foregroundImageUrl && (
                    <PreloadImage
                        url={ foregroundImageUrl }
                        onPreloadComplete={ this.handleForegroundPreloaded }
                    />
                ) }
                <PreloadImage
                    url={ backgroundImageUrl }
                    onPreloadComplete={ this.handleBackgroundPreloaded }
                />

                { !imagesLoaded && <Spin className="instant-play-spinner" /> }
                { imagesLoaded && (
                    <>
                        { /* MOBILE VIEW */ }
                        <div className="mobile-view">
                            <NackleProgramTile
                                title={ romName }
                                description={ romDescription }
                                imgSrc={ backgroundImageUrl }
                                imgAlt="Program Image"
                                extra={
                                    <div className="extra">
                                <AltLocaleString code={ `rom.${ romId }.name` }>
                                    { altLabel => (
                                        <Button
                                            size="medium"
                                            shape="round"
                                            onClick={ this.handleClick }
                                            rightIcon={ <CaretRight /> }
                                            type="primary"
                                            aria-label={ altLabel || label }
                                            title={ altLabel || label }
                                        >
                                            <Translate id={ 'arcade.webapp.playButton' } parseHtml />
                                        </Button>
                                    ) }
                                </AltLocaleString>
                                    </div>
                                }
                            />
                        </div>
                        { /* DESKTOP VIEW */ }
                        <div className="desktop-view">
                            <div className="instant-play-card">
                                <div className="instant-play-image">
                                    <img src={ backgroundImageUrl } alt={ '' } />
                                </div>
                                <div className="instant-play-content">
                                    <div className="instant-play-info">
                                        <div className="instant-play-infoData">
                                            <Title className="title" level={ 4 }>
                                                { romName }
                                            </Title>
                                            <Title className="description" level={ 4 }>
                                                <span
                                                    className="description-text"
                                                    onMouseEnter={ ( event ) => this.handleDescriptionHover( event, romDescription ) }
                                                >
                                                    { romDescription }
                                                </span>
                                            </Title>
                                        </div>
                                    </div>
                            <AltLocaleString code={ `rom.${ romId }.name` }>
                                { altLabel => (
                                    <Button
                                        className="instant-play-button"
                                        type="primary"
                                        shape="round"
                                        onClick={ this.handleClick }
                                        rightIcon={ <CaretRight /> }
                                        aria-label={ altLabel || label }
                                        title={ altLabel || label }
                                    >
                                        <Translate id={ 'arcade.webapp.playButton' } parseHtml />
                                    </Button>
                                ) }
                            </AltLocaleString>
                                </div>
                            </div>
                        </div>
                    </>
                ) }
            </div>
        );
    }

    handleClick = () => {
        const { cabinet, openGame, roomId } = this.props;
        openGame( cabinet.cabinetId, roomId ).catch( ( e ) => console.error( e ) );
    };
 
    handleDescriptionHover = ( event, description ) => {
        const element = event.currentTarget;
        const hasOverflow = element.scrollHeight > element.clientHeight;
 
        if ( hasOverflow ) {
            element.setAttribute( 'title', description || '' );
            return;
        }
 
        element.removeAttribute( 'title' );
    };
 
    handleForegroundPreloaded = () => this.setState( { foregroundLoaded: true } );
    handleBackgroundPreloaded = () => this.setState( { backgroundLoaded: true } );
}

export default connect( null, mapDispatchToProps )( InstantPlay );
